import axios from "axios";

//TEST = https://vxp5zgzxmk.execute-api.us-east-1.amazonaws.com/PROD
//PROD = https://0wm4a8yx47.execute-api.us-east-1.amazonaws.com/PROD
const instance = axios.create({
    baseURL: "https://prod.api.pmcc.site",
});

export default instance;